import React from 'react';

const PaymentMethodsPage = () => {
  return (
    <div className="payment-methods-page">
      <section className="payment-methods-section">
        <div className="container">
          <div className="section-header">
            <h1 className="section-title">Métodos de Pago</h1>
            <p className="section-description">
              En GesOps LLC facilitamos el proceso de pago para nuestros servicios. 
              Aceptamos las siguientes formas de pago:
            </p>
          </div>

          <div className="payment-methods-grid">
            {/* Transferencia Bancaria */}
            <div className="payment-card">
              <div className="payment-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="5" width="20" height="14" rx="2"/>
                  <line x1="2" y1="10" x2="22" y2="10"/>
                </svg>
              </div>
              <h3 className="payment-title">Transferencia Bancaria</h3>
              <div className="payment-details">
                <div className="detail-item">
                  <strong>Banco:</strong>
                  <p>Por definir</p>
                </div>
                <div className="detail-item">
                  <strong>Nombre de la cuenta:</strong>
                  <p>GesOps LLC</p>
                </div>
                <div className="detail-item">
                  <strong>Tipo de cuenta:</strong>
                  <p>Cuenta de Negocios</p>
                </div>
                <div className="detail-item">
                  <strong>Número de cuenta:</strong>
                  <p>Por definir</p>
                </div>
                <div className="detail-item">
                  <strong>Routing Number:</strong>
                  <p>Por definir</p>
                </div>
              </div>
              <div className="payment-note">
                <p>
                  <strong>Importante:</strong> Después de realizar la transferencia, 
                  envíe el comprobante a info@gesops.com con su nombre completo y 
                  número de caso o servicio contratado.
                </p>
              </div>
            </div>

            {/* Zelle */}
            <div className="payment-card featured">
              <div className="payment-badge">Más Rápido</div>
              <div className="payment-icon zelle-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
                </svg>
              </div>
              <h3 className="payment-title">Zelle</h3>
              <div className="payment-details">
                <div className="detail-item">
                  <strong>Correo electrónico:</strong>
                  <p className="highlight-email">info@gesops.com</p>
                </div>
                <div className="detail-item">
                  <strong>Nombre registrado:</strong>
                  <p>GesOps LLC</p>
                </div>
                <div className="detail-item">
                  <strong>Número:</strong>
                  <p>+1 (804) 960-8133</p>
                </div>
              </div>

              <div className="payment-note">
                <p>
                  <strong>Nota:</strong> Los pagos por Zelle son instantáneos. 
                  Recibirá confirmación inmediata por correo electrónico.
                </p>
              </div>
            </div>
          </div>

          <div className="payment-info-section">
            <div className="info-box">
              <h3>Información Importante</h3>
              <ul>
                <li>
                  <strong>Confirmación de pago:</strong> Todos los pagos serán confirmados 
                  dentro de las 24 horas hábiles siguientes.
                </li>
                <li>
                  <strong>Comprobante:</strong> Siempre solicite y guarde su comprobante 
                  de pago para sus registros.
                </li>
                <li>
                  <strong>Concepto de pago:</strong> Al realizar el pago, incluya su nombre 
                  completo y el servicio contratado en el concepto.
                </li>
                <li>
                  <strong>Dudas:</strong> Para cualquier consulta sobre pagos, contáctenos 
                  a info@gesops.com o a través de WhatsApp Business.
                </li>
              </ul>
            </div>
          </div>

          <div className="payment-security">
            <div className="security-badge">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              <div>
                <h4>Pagos Seguros</h4>
                <p>Todas las transacciones son seguras y verificadas por GesOps LLC</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PaymentMethodsPage;
